import AlertTriangleIcon from '@assets/icons/alert-triangle.svg';
import i18n from '@/utils/i18n';
import { EmptyState } from '@/components/empty-state';
import { useTheme } from '@/contexts/theme-context';
import type { ViewStyle } from 'react-native';

interface Props {
  onRetry: () => void;
  style?: ViewStyle;
}

export const OrderInboundsOrderListErrorState: React.FC<Props> = ({
  onRetry,
  style,
}) => {
  const theme = useTheme();

  return (
    <EmptyState
      ctaText={i18n.t('order_inbounds.error_state.retry')}
      description={i18n.t('order_inbounds.error_state.description')}
      icon={<AlertTriangleIcon stroke={theme.sk.color.icon.primary} />}
      onPress={onRetry}
      style={style}
      title={i18n.t('order_inbounds.error_state.title')}
    />
  );
};
